export const SHIP_DATE_CLEARED_MESSAGE = "Ship date can't be cleared once delivery is scheduled.";
//# sourceMappingURL=ship-date-cleared-message.js.map